import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { trackOrderStatus } from "../../../utility/analyticsUtility";

const PaymentFailure = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [countdown, setCountdown] = useState(5);

  useEffect(() => {
    const orderId = searchParams.get('orderId') || searchParams.get('req_transaction_uuid');
    const orderValue = parseFloat(searchParams.get('orderValue') || '0');
    const paymentMethod = searchParams.get('paymentMethod') || 'Card';
    const reason = searchParams.get('message') || searchParams.get('reason_code') || 'Transaction declined';

    // Track failed payment
    if (orderId) {
      trackOrderStatus('failed', {
        orderId: orderId,
        orderValue: orderValue,
        paymentMethod: paymentMethod,
        errorReason: reason,
      });
    }

    // Optional: Update order status in your backend
    // updateOrderStatus(transactionId, 'failed');

    const timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev <= 1) {
          navigate('/checkout'); // Back to checkout
          return 0;
        }
        return prev - 1;
      });
    }, 1000);

    return () => clearInterval(timer);
  }, [searchParams, navigate]);

  return (
    <div style={{ 
      textAlign: 'center', 
      padding: '50px 20px',
      maxWidth: '600px',
      margin: '0 auto'
    }}>
      <div style={{ 
        backgroundColor: '#f8d7da',
        border: '1px solid #f5c6cb',
        borderRadius: '8px',
        padding: '30px',
        marginBottom: '20px'
      }}>
        <h2 style={{ color: '#721c24', marginBottom: '20px' }}>
          ❌ Payment Failed
        </h2>
        <p style={{ color: '#721c24', fontSize: '18px' }}>
          We couldn't process your payment. Please try again.
        </p>
      </div>

      <div style={{ marginBottom: '30px' }}>
        <p><strong>Reason:</strong> {searchParams.get('message') || 'Transaction declined'}</p>
        <p><strong>Reference:</strong> {searchParams.get('req_reference_number')}</p>
      </div>

      <p>Redirecting back to checkout in <strong>{countdown}</strong> seconds...</p>
      
      <div style={{ marginTop: '20px' }}>
        <button 
          onClick={() => navigate('/checkout')}
          style={{
            padding: '12px 24px',
            backgroundColor: '#dc3545',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '16px',
            marginRight: '10px'
          }}
        >
          Try Again
        </button>
        
        <button 
          onClick={() => navigate('/contact')}
          style={{
            padding: '12px 24px',
            backgroundColor: '#6c757d',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            cursor: 'pointer',
            fontSize: '16px'
          }}
        >
          Contact Support
        </button>
      </div>
    </div>
  );
};
export default PaymentFailure;